// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/B-Titr/B-Titr-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/B_Yekan/Yekan.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Far_Nazanin/Far_Nazanin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Century_Gothic/GOTHIC.TTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Titr";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
    font-family: "Yekan";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
    font-family: "Nazanin";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
    font-family: "Gothic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.col-1 { width: 8.33%;  }
.col-2 { width: 16.66%; }
.col-3 { width: 25%;    }
.col-4 { width: 33.33%; }
.col-5 { width: 41.66%; }
.col-6 { width: 50%;    }
.col-7 { width: 58.33%; }
.col-8 { width: 66.66%; }
.col-9 { width: 75%;    }
.col-10{ width: 83.33%; }
.col-11{ width: 91.66%; }
.col-12{ width: 100%;   }

.row div{ 
    float: right;
 }

div {
    display: block;
    text-align: center;
}
.row::after {
    content: '    ';
    text-align: center;
    display: block;
    clear: both;
}

.row {
    width: 100%;
}

img, 
button, 
input[type="button"], 
input[type="submit"], 
input[type="reset"],
a img,
.btn,
svg,
i {
    -webkit-user-select: none;
    user-select: none;
}

body {
    width: 100%;
    padding: 0 0;
    max-width: 390px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow-x: hidden;
    box-sizing: border-box;
}
html, body {
  overflow-x: hidden;
}

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: #191A17;
    background: #a7fa00 !important;
}

::-webkit-scrollbar-thumb {
    background: #93e900;
    background: #474D3D;
    border-radius: 10px;
    -webkit-transition: background 0.3s ease;
    transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
    background: #85995C;
}

html {
    scrollbar-width: thin;
    scrollbar-color: #474D3D #191A17;
}

a {
    text-decoration: none;
    outline: none !important;
    -webkit-tap-highlight-color: transparent;
}
a:focus, a:active {
    outline: none !important;
}

img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    -webkit-user-select: none;
            user-select: none;
    -webkit-user-drag: none;
}

video {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    -webkit-user-select: none;
            user-select: none;
    -webkit-user-drag: none;
}

h1, h2, h3, h4, h5, h6, p, span, ul, li, i, b, small {
    /* direction: ltr; */
    font-weight: 400;
    color: #ADB2A1;
    font-style: Regular;
}

textarea, input, select, option {
    direction: ltr;
    line-height: 1.6;
    text-align: right;
}

input:focus {
    outline: none !important;
}

select:focus {
    outline: none !important;
}
::selection {
    background-color: rgba(133, 153, 92, 0.85);
    color: #FFFFFF;
}

::-moz-selection {
    background-color: rgba(133, 153, 92, 0.85);
    color: #FFFFFF;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    appearance: textfield;
}

button {
    border: none;
    cursor: pointer;
    background-color: #7B8073;
}

@keyframes storyProgress {
  from { width: 0%; }
  to { width: 100%; }
}


@media (min-width: 1200px) {
    body {
        max-width: 1440px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/BaseStructure.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,4CAAiD;AACrD;;AAEA;IACI,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;IACtB,4CAAsD;AAC1D;;AAEA;IACI,qBAAqB;IACrB,4CAAoD;AACxD;;AAEA,SAAS,YAAY,GAAG;AACxB,SAAS,aAAa,EAAE;AACxB,SAAS,UAAU,KAAK;AACxB,SAAS,aAAa,EAAE;AACxB,SAAS,aAAa,EAAE;AACxB,SAAS,UAAU,KAAK;AACxB,SAAS,aAAa,EAAE;AACxB,SAAS,aAAa,EAAE;AACxB,SAAS,UAAU,KAAK;AACxB,SAAS,aAAa,EAAE;AACxB,SAAS,aAAa,EAAE;AACxB,SAAS,WAAW,IAAI;;AAExB;IACI,YAAY;CACf;;AAED;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;;;;IASI,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;EACE,kBAAkB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,wCAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,wCAAwC;AAC5C;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IAEI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;EACE,OAAO,SAAS,EAAE;EAClB,KAAK,WAAW,EAAE;AACpB;;;AAGA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@font-face {\r\n    font-family: \"Titr\";\r\n    src: url(\"./assets/fonts/B-Titr/B-Titr-Bold.ttf\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Yekan\";\r\n    src: url(\"./assets/fonts/B_Yekan/Yekan.ttf\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Nazanin\";\r\n    src: url(\"./assets/fonts/Far_Nazanin/Far_Nazanin.ttf\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Gothic\";\r\n    src: url(\"./assets/fonts/Century_Gothic/GOTHIC.TTF\");\r\n}\r\n\r\n.col-1 { width: 8.33%;  }\r\n.col-2 { width: 16.66%; }\r\n.col-3 { width: 25%;    }\r\n.col-4 { width: 33.33%; }\r\n.col-5 { width: 41.66%; }\r\n.col-6 { width: 50%;    }\r\n.col-7 { width: 58.33%; }\r\n.col-8 { width: 66.66%; }\r\n.col-9 { width: 75%;    }\r\n.col-10{ width: 83.33%; }\r\n.col-11{ width: 91.66%; }\r\n.col-12{ width: 100%;   }\r\n\r\n.row div{ \r\n    float: right;\r\n }\r\n\r\ndiv {\r\n    display: block;\r\n    text-align: center;\r\n}\r\n.row::after {\r\n    content: '    ';\r\n    text-align: center;\r\n    display: block;\r\n    clear: both;\r\n}\r\n\r\n.row {\r\n    width: 100%;\r\n}\r\n\r\nimg, \r\nbutton, \r\ninput[type=\"button\"], \r\ninput[type=\"submit\"], \r\ninput[type=\"reset\"],\r\na img,\r\n.btn,\r\nsvg,\r\ni {\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n    padding: 0 0;\r\n    max-width: 390px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    position: relative;\r\n    overflow-x: hidden;\r\n    box-sizing: border-box;\r\n}\r\nhtml, body {\r\n  overflow-x: hidden;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 6px;\r\n    height: 6px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background: #191A17;\r\n    background: #a7fa00 !important;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background: #93e900;\r\n    background: #474D3D;\r\n    border-radius: 10px;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n    background: #85995C;\r\n}\r\n\r\nhtml {\r\n    scrollbar-width: thin;\r\n    scrollbar-color: #474D3D #191A17;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n    outline: none !important;\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\na:focus, a:active {\r\n    outline: none !important;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    object-fit: cover;\r\n    user-select: none;\r\n    -webkit-user-drag: none;\r\n}\r\n\r\nvideo {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    object-fit: cover;\r\n    user-select: none;\r\n    -webkit-user-drag: none;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6, p, span, ul, li, i, b, small {\r\n    /* direction: ltr; */\r\n    font-weight: 400;\r\n    color: #ADB2A1;\r\n    font-style: Regular;\r\n}\r\n\r\ntextarea, input, select, option {\r\n    direction: ltr;\r\n    line-height: 1.6;\r\n    text-align: right;\r\n}\r\n\r\ninput:focus {\r\n    outline: none !important;\r\n}\r\n\r\nselect:focus {\r\n    outline: none !important;\r\n}\r\n::selection {\r\n    background-color: rgba(133, 153, 92, 0.85);\r\n    color: #FFFFFF;\r\n}\r\n\r\n::-moz-selection {\r\n    background-color: rgba(133, 153, 92, 0.85);\r\n    color: #FFFFFF;\r\n}\r\n\r\ninput[type=\"number\"]::-webkit-inner-spin-button,\r\ninput[type=\"number\"]::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\ninput[type=\"number\"] {\r\n    -moz-appearance: textfield;\r\n    appearance: textfield;\r\n}\r\n\r\nbutton {\r\n    border: none;\r\n    cursor: pointer;\r\n    background-color: #7B8073;\r\n}\r\n\r\n@keyframes storyProgress {\r\n  from { width: 0%; }\r\n  to { width: 100%; }\r\n}\r\n\r\n\r\n@media (min-width: 1200px) {\r\n    body {\r\n        max-width: 1440px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
